import request from '@/utils/requset'

//上传图片
export function uploadImg(data) {
  return request({
    url: `/api/common/uploadImg`,
    method: 'post',
    data: data,
    headers: {
      'content-type': 'multipart/form-data;'
    }
  })
}

// 作品查看记录
export function viewProduction(mid) {
  return request({
    url: `h5/model_objects/view_count/add`,
    method: 'post',
    data: { mid }
  })
}

// 个人作品列表
export function myProductions(data) {
  return request({
    url: `h5/model_objects/me/index`,
    method: 'get',
    params: data
  })
}

// 删除作品
export function destroy(id) {
  return request({
    url: `h5/model_objects/destroy`,
    method: 'delete',
    data: { mid: id }
  })
}

// 实验成绩
export function experScore() {
  return request({
    url: `/h5/experiment/score`,
    method: 'get',
  })
}

// 实验成绩详情
export function scoreDetail(id) {
  return request({
    url: `/h5/experiment/scoreDetail/${id}`,
    method: 'get',
  })
}

//排行榜
export function ranking(id) {
  return request({
    url: `h5/experiment/ranking`,
    method: 'post',
    data: { course_id: id }
  })
}

// 实验报告列表
export function experimentReport() {
  return request({
    url: 'h5/experiment/report',
    method: 'get',
  })
}
//实验报告详情
export function reportDetail(id) {
  return request({
    url: `h5/experiment/reportDetail/${id}`,
    method: 'get',
  })
}

//修改实验报告
export function reportEdit(data) {
  return request({
    url: `h5/experiment/reportEdit/${data.id}`,
    method: 'post',
    data: {
      purpose: data.purpose,
      content: data.content,
      experience: data.experience
    }
  })
}

// 修改密码
export function modifyPassword(data) {
  return request({
    url: `h5/user/modifyPassword`,
    method: 'post',
    data: data
  })
}

// 修改头像
export function modifyInfo(data) {
  return request({
    url: `h5/user/modifyInfo`,
    method: 'post',
    data: data,
    headers: {
      'content-type': 'multipart/form-data;'
    }
  })
}
//修改个人信息
export function modifyInfos(data) {
  return request({
    url: `h5/user/modifyInfo`,
    method: 'post',
    data: data,
  })
}

// 已学课程
export function studied() {
  return request({
    url: `h5/course/hasStudy`,
    method: 'get'
  })
}
//重新学习
export function studyAgainR(id) {
  return request({
    url: `h5/course/studyAgain/${id}`,
    method: 'post'
  })
}
//问题列表
export function questionLists() {
  return request({
    url: `h5/exchange/lists`,
    method: 'get'
  })
}
//问题详情
export function questionInfo(id) {
  return request({
    url: `/h5/exchange/detail/${id}`,
    method: 'get'
  })
}
//问题追问
export function questioning(data) {
  console.log('传入的data值:', data)
  return request({
    url: `/h5/exchange/question/${data.id}`,
    method: 'post',
    data: {
      question: data.question
    }
  })
}


